import Amplify from '@aws-amplify/core';
import { getJwtToken } from 'services/authentication';

export function configureAmplify() {
  Amplify.configure({
    API: {
      endpoints: [
        {
          name: import.meta.env.VITE_API_GATEWAY_NAME,
          endpoint: import.meta.env.VITE_API_GATEWAY_URL,
          region: import.meta.env.VITE_AWS_REGION,
          custom_header: async () => ({
            Authorization: await getJwtToken(),
          }),
        },
      ],
    },
    Auth: {
      mandatorySignIn: true,
      region: import.meta.env.VITE_AWS_REGION,
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolWebClientId: import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID,
    },
  });
}
